<template>
  <div class="article-container" style="padding-bottom: 80px;">
    <!-- 頁頭 -->
    <header class="article-header mb-5">
      <div class="container">
        <h1 class="article-title display-4 fw-bold mb-3">{{ article.title }}</h1>
        <div class="article-meta text-muted">
          <span class="me-3"><i class="bi bi-person me-1"></i>{{ article.author }}</span>
          <span class="me-3"><i class="bi bi-clock me-1"></i>{{ article.publishTime }}</span>
          <span><i class="bi bi-eye me-1"></i>閱讀 {{ article.views }}</span>
        </div>
      </div>
    </header>

    <!-- 主內容區 -->
    <main class="article-content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <!-- 富文本內容區域 -->
            <div class="content-html" v-html="article.content" style="line-height: 1.8; font-size: 1.1rem;"></div>
            

          </div>
        </div>
      </div>
    </main>


  </div>
</template>

<script>
export default {
  
  name: "App",
  data() {
    return {
      article: {
        title: '文章標題示例',
        author: '派迪軟件',
        publishTime: '2023-08-20',
        views: 1234,
        content: '<p>這裏是富文本內容示例...</p>' // 實際使用時替換為真實數據
      },
      type: '',
      id: '',
      html: '',
      editorConfig: {
        placeholder: '请输入内容',
        MENU_CONF: {
          uploadImage: {
            server: '/api/file/upload',
            fieldName: "file",
            // 自定义插入图片
            customInsert(res, insertFn) {
              insertFn(`/api/file/download/${res.data}`, "", "")
            },
          }
        }
      },
      mode: 'default',

    }
  },
  created() {
    const query = this.$route.query;

    this.type = query.type;
    console.log(this.type)

    if (this.type == 0) {
      //新闻
      if (query.id) {
        try {
          this.id = JSON.parse(decodeURIComponent(query.id));

          this.NewsAddReadCount(this.id)

        } catch (error) {
          console.error('解析 JSON 数据时出错:', error);
        }
      }
    } else if (this.type == 1) {
      // 案例
      if (query.id) {
        try {
          this.id = JSON.parse(decodeURIComponent(query.id));

          this.ProductAddReadCount(this.id)

        } catch (error) {
          console.error('解析 JSON 数据时出错:', error);
        }
      }
    }

  },
  methods: {
    //新闻自增阅读数
    NewsAddReadCount(id) {
      this.$axios.post("/news/addReadCount", { id: id })
        .then(res => {
          console.log(res)
          this.article.views = res.data.data.read_count
          this.article.title = res.data.data.title
          this.article.publishTime = res.data.data.date
          this.article.content = res.data.data.content
        })
    },
    //产品案例自增阅读数
    ProductAddReadCount(id) {
      this.$axios.post("/product/addReadCount", { id: id })
        .then(res => {
          console.log(res)
          this.article.views = res.data.data.read_count
          this.article.title = res.data.data.title
          this.article.publishTime = res.data.data.date
          this.article.content = res.data.data.content
        })
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
  }
}
</script>

<style scoped>
.article-header {
  padding: 4rem 0;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.article-title {
  color: #2c3e50;
  line-height: 1.2;
}

.article-meta {
  font-size: 0.95rem;
}

.content-html {
  color: #4a4a4a;
}

.content-html ::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1.5rem 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.content-html ::v-deep h2,
.content-html ::v-deep h3 {
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;
  color: #2c3e50;
  font-weight: 600;
}

.content-html ::v-deep a {
  color: #3a86ff;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .article-header {
    padding: 2rem 0;
  }

  .article-title {
    font-size: 2rem;
  }
}

.justify-content-center {
  flex-direction: column !important;
}

.col-lg-8 {
  width: 100% !important;
}
</style>